export const UPDATE_FORM_BUILDER_SETTINGS = 'FORM_BUILDER_SETTINGS/UPDATE_FORM_BUILDER_SETTINGS'
export const UPDATE_FORM_BUILDER_SETTINGS_FAILED = 'FORM_BUILDER_SETTINGS/UPDATE_FORM_BUILDER_SETTINGS_FAILED'
export const UPDATE_FORM_BUILDER_SETTINGS_SUCCESS = 'FORM_BUILDER_SETTINGS/UPDATE_FORM_BUILDER_SETTINGS_SUCCESS'
